<template>
    <div>
        <main-banner v-bind:image="'src/assets/images/' + image"></main-banner>
        <h2 class="blue--text mt-5">{{$t('pages.clients.hospitals.title')}}</h2>
        <div class="mt-2 section-content" v-html="$t('pages.clients.hospitals.about')"></div>
        <h2 class="blue--text mt-5">{{$t('pages.clients.hospitals.project.title')}}</h2>
        <div class="mt-2 section-content" v-html="$t('pages.clients.hospitals.project.content')"></div>
        <h2 class="blue--text mt-5">{{$t('pages.clients.hospitals.contact.title')}}</h2>
        <div class="mt-2 section-content" v-html="$t('pages.clients.hospitals.contact.content')"></div>
      <div class="mt-2 section-content">
        <v-btn block href="/download/raportownik_szpitalny.zip">
          {{ $t('pages.clients.hospitals.contact.raportownik') }}
        </v-btn>
      </div>
    </div>
</template>
<script>
    import MainBanner from '../sections/MainBanner.vue'

    export default {
        name: 'hospitals',
        components: {
            'main-banner': MainBanner
        },
        data() {
            return {
                image: 'hospitals.jpg'
            };
        }
    };
</script>



// WEBPACK FOOTER //
// Hospitals.vue?32d15f9c